'use client';

import '@ui5/webcomponents-fiori/dist/ShellBar.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `ShellBar` is meant to serve as an application header and includes numerous built-in features, such as: logo, profile image/icon, title, search field, notifications and so on.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/fiori-ShellBar)
 */
const ShellBar = withWebComponent('ui5-shellbar', ['notificationsCount', 'primaryTitle', 'secondaryTitle'], ['showCoPilot', 'showNotifications', 'showProductSwitch', 'showSearchField'], ['logo', 'menuItems', 'profile', 'searchField', 'startButton'], ['co-pilot-click', 'logo-click', 'menu-item-click', 'notifications-click', 'product-switch-click', 'profile-click']);
ShellBar.displayName = 'ShellBar';
export { ShellBar };